import get from 'lodash/get';

export const getFilters = state => state.form.adminCashDesksFilters;

export const getModalData = modalName => state => get(state, `adminCashDesks.modals.${modalName}.data`, {});

export const getCashDeskById = cashRegisterNum => state => {
    const cities = get(state, 'adminCashDesks.data', []);
    return cities.find((a) => a.cashRegisterNum === cashRegisterNum);
};

export const isNewModal = modalName => state => {
    return get(state, `adminCashDesks.modals.${modalName}.data.new`, false);
};
